import React, { useEffect, useState } from 'react'
import apiClient from '../apiClient';
import { SSO_URL } from '../env';
import { GET_GROUP_DETAILS } from '../apiClient/apiEndpoints';



const ParentGroup = ({uuid}) => {
    const [orgImage, setOrgImage] = useState(false);
    const [totalApplication, setTotalApplication]= useState(0);
    const [totalResource, setTotalResource]= useState(0);
    const [totalAmount, setTotalAmount]= useState(0);
    const [details, setDetails]= useState(null);

    const getSubscriptionDetails = async() =>{
        try {
            let data = await apiClient.get(`${SSO_URL}${GET_GROUP_DETAILS}/${uuid}`);
            setDetails(data)           
            setTotalResource(data.subscriptions.resources);
            setTotalApplication(data.subscriptions.applications);            
            setTotalAmount(data.subscriptions.amount);

        } catch (error) {
            console.log(error);
        }
    }

    useEffect(()=>{ 
       getSubscriptionDetails()
    },[uuid]);



    return (
        <>
            <div className="parent-group">
                <div className="group-function-parent">
                    <div className="group-info">
                        <div className="profile">
                            <div className="bg">
                                {orgImage ? (
                                    <img
                                        src="https://cdn.simulanis.io/sso/uno/production/teams/a980ec6b-959e-4d68-83cc-4ca888f7f936/logo/9425bbfc-d2b4-4326-9526-bb1509b096e9.png"
                                        referrerPolicy="no-referrer"
                                    />
                                ) : (
                                    <span className="initials">SS</span>
                                )}
                            </div>
                        </div>
                        <p className="name">{details?.name || ""}</p>
                        <p className="groupid m-0">{details?.data?.identifier || ""}</p>
                        <p className="amount">₹ {totalAmount} </p>
                    </div>
                    <div className="group-functions">
                        <div className="function-item">
                            <div className="group-info-item">
                                <div className="text-detail">
                                    <p> Applications </p>
                                    <div className="text-output">
                                        {totalApplication}<span></span>
                                    </div>
                                </div>
                            </div>
                            <div className="group-info-item">
                                <div className="text-detail">
                                    <p> Resources </p>
                                    <div className="text-output">
                                        {totalResource}<span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ParentGroup
